import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { GerinusService } from '../lib/gerinus.service';
import { RequestService } from './request.service';
import { OrganizationService } from './organization.service';
import { ProcessService } from './process.service';
import { UserService } from './user.service';
import { GlobalService } from '../lib/global.service';
import { Observable, of } from 'rxjs';
import { ApplicantRequestService } from './applicant-request.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { SecondsToDaysPipe } from 'src/app/date-to-days-pipe.pipe';

@Injectable()
export class DashboardService extends GerinusService {
	constructor(
		public http: HttpClient,
		public requestService: RequestService,
		public processService: ProcessService,
		public organizationService: OrganizationService,
		public userService: UserService,
		public global: GlobalService,
		public applicantRequestService: ApplicantRequestService,
		private datePipe: DatePipe
	) {
		super(http);
	}

	async getTotal(entity: string, where: string = ''): Promise<number> {
		return new Promise<number>((resolve) => {
			if (this[entity]) {
				this[entity].listAll(where, 0).subscribe({
					next: (response: any) => {
						const total = response.data.length;
						resolve(total);
					},
				});
			} else {
				resolve(0);
			}
		});
	}

	getTotalObservable(entity: string, where: string = ''): Observable<any> {
		return this[entity].listAll(where, 0)
	}

	getTotalObservableScreeningProcess(entity: string, where: string = ''): Observable<any> {
		return this[entity].listAll(where, 0)
	}

	
	generateListPDF(entitys: any): void {
		const listEntity: any = {
		  requests: {
			title: 'Total de Solicitações',
			titles: ['NÚMERO', 'CPF', 'SOLICITANTE', 'ASSUNTO', 'STATUS', 'DATA DA SOLICITAÇÃO'],
			columns: [
			  { key: 'SOL_NumeroSolicitacao' },
			  { key: 'PE_CPF', format: this.formatCpfCnpj },
			  { key: 'PE_Nome' },
			  { key: 'AS_Descricao' },
			  { key: 'SOL_Status', format: this.getStatusDescriptionRequest },
			  { key: 'SOL_DataSolicitacao', format: (date: any) => this.formatDateRequest(date) }
			]
		  },
		  process: {
			title: 'Total de Processos',
			titles: ['NUP', 'DATA DE RECEBIMENTO', 'ASSUNTO', 'DEPARTAMENTO', 'STATUS', 'RESPONSÁVEL', 'RECEBIDO'],
			columns: [
			  { key: 'PRC_NumeroProcesso' },
			  { key: 'PRC_DataRecebimento', format: (date: any) => this.formatDateProcess(date) },
			  { key: 'AS_Descricao' },
			  { key: 'nomeDepartamentoAtual' },
			  { key: 'Status', format: this.getStatusDescriptionProcess },
			  { key: 'responsavel' },
			  { key: 'time_in_current_status', format: (seconds: any) => this.formatDateDayHoursMin(seconds) }
			]
		  },
		  usuario: {
			title: 'Total de Usuários',
			titles: ['NOME', 'GRUPO DE USUÁRIO', 'ÓRGÃO', 'DEPARTAMENTO', 'VÍNCULO'],
			columns: [
			  { key: 'PE_Nome' },
			  { key: 'GRP_Descricao' },
			  { key: 'OR_Descricao' },
			  { key: 'DEP_Descricao' },
			  { key: 'USR_Vinculo', format: this.toUppercase }
			]
		  },
		  orgao: {
			title: 'Total de Órgãos',
			titles: ['ÓRGÃO', 'SIGLA'],
			columns: [
			  { key: 'OR_Descricao' },
			  { key: 'OR_Sigla' }
			]
		  },
		  unassignedProcess: {
			title: 'Processos sem atribuição',
			titles: ['NUP', 'DATA DE RECEBIMENTO', 'ASSUNTO', 'DEPARTAMENTO', 'STATUS', 'RECEBIDO'],
			columns: [
				{ key: 'PRC_NumeroProcesso' },
				{ key: 'PRC_DataRecebimento', format: (date: any) => this.formatDateProcess(date) },
				{ key: 'AS_Descricao' },
				{ key: 'nomeDepartamentoAtual' },
				{ key: 'Status', format: this.getStatusDescriptionProcess },
				{ key: 'time_in_current_status', format: (seconds: any) => this.formatDateDayHoursMin(seconds) }
			]
		  },
		  screeningProcess: {
			title: 'Processos abertos triagem',
			titles: ['NUP', 'DATA DE RECEBIMENTO', 'ASSUNTO', 'DEPARTAMENTO', 'STATUS', 'RESPONSÁVEL', 'RECEBIDO'],
			columns: [
				{ key: 'PRC_NumeroProcesso' },
				{ key: 'PRC_DataRecebimento', format: (date: any) => this.formatDateProcess(date) },
				{ key: 'AS_Descricao' },
				{ key: 'nomeDepartamentoAtual' },
				{ key: 'Status', format: this.getStatusDescriptionProcess },
				{ key: 'responsavel' },
				{ key: 'time_in_current_status', format: (seconds: any) => this.formatDateDayHoursMin(seconds) }
			]
		  }
		};
	
		const doc = new jsPDF('p', 'mm', 'a4');
		const pageWidth = doc.internal.pageSize.getWidth();
		const currentDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy HH:mm:ss');
	
		let firstPage = true;
	
		doc.setFont('Inter-SemiBold');
		doc.setFontSize(14);
		doc.text('RELATÓRIO GERAL DO DASHBOARD', pageWidth / 2, 12, { align: 'center' });
	
		for (const key in entitys) {
		  const entityData = listEntity[key];
		  if (!entityData) continue;
	
		  if (!firstPage) doc.addPage();
		  firstPage = false;
	
		  doc.setFontSize(8);
		  doc.text(entityData.title, pageWidth / 2, 20, { align: 'center' });
	
		  const tableData = entitys[key].data.map((item: any) =>
			entityData.columns.map((col: any) =>
			  col.format ? col.format(item[col.key], item) : (item[col.key] ?? '')
			)
		  );
	
		  autoTable(doc, {
			head: [entityData.titles],
			body: tableData,
			startY: 25,
			margin: { top: 25 },
			styles: { valign: 'middle', fontSize: 8 },
			headStyles: { fontSize: 6 },
			bodyStyles: { fontSize: 6 }
		  });
	
		  const pageHeight = doc.internal.pageSize.height;
		  doc.setFontSize(8);
		  doc.text(`Gerado em: ${currentDate}`, 14, pageHeight - 10);
		}
	
		doc.save('Relatorio-dashboard.pdf');
	}

	  getStatusDescriptionRequest(currentRequestStatus: number) {
        const statusDescriptions = {
            0: 'Triagem',
            1: 'Aceita',
            2: 'Em correção',
            3: 'Anulada',
            4: 'Corrigida',
			5: 'Assinatura pendente'
        };

        return statusDescriptions[currentRequestStatus];
    }

	getStatusDescriptionProcess(processStatus: number): string {
        const statusDescriptions = {
            1: 'Novo',
            2: 'Em Andamento',
            3: 'Arquivado',
            4: 'Concluído',
            5: 'Em Correção',
            6: 'Vencido',
            7: 'Anulado',
            8: 'Respondido'
        };

        return statusDescriptions[processStatus];
    }

	private formatDateRequest(date: any): string {
		return this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss') ?? '';
	}

	private formatDateDayHoursMin = (seconds: any) => {
		return new SecondsToDaysPipe().transform(seconds);
	}

	private formatDateProcess = (date:  any) => {
		return new DatePipe('pt-BR').transform(date, 'dd/MM/yyyy HH:mm:ss', 'UTC');
	}

	private toUppercase(value: string): string {
		return value ? value.toUpperCase() : '';
	  }
}
